module.exports = __webpack_public_path__ + "src/images/basic_vs_premium.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/basic_vs_premium.png
// module id = 1135
// module chunks = 0